import rolesModules from './roles-modules';
import rolesSubModules from './roles-sub-modules';
import rolesHandler from '../handler';

export default {
    rolesModules,
    rolesSubModules,
    rolesHandler
}